import { ENVIRONMENT } from './ExecutionEnvironmentName';
import * as ExecutionEnvironmentSettings from './ExecutionEnvironmentSettings';

/**
 * Client-side execution environment (hostname, API base URLs for the SPA).
 */
export default class ExecutionEnvironment {
  /**
   * @param {import('./ExecutionEnvironmentName').ExecutionEnvironmentName} name
   * @param {object} [options]
   * @param {string} [options.hostname] - Host name used when resolving (for tests)
   */
  constructor(name, options = {}) {
    this.name = name;
    this.hostname = options.hostname ?? '';
  }

  /** @returns {boolean} */
  isProduction() {
    return this.name === ENVIRONMENT.PRODUCTION;
  }

  /** @returns {boolean} */
  isStaging() {
    return this.name === ENVIRONMENT.STAGING;
  }

  /** @returns {boolean} */
  isDevelopment() {
    return this.name === ENVIRONMENT.DEVELOPMENT;
  }

  /** @returns {boolean} */
  usesStagingApi() {
    return ExecutionEnvironmentSettings.usesStagingApi(this.name);
  }

  /** @returns {string} */
  get apiBase() {
    return ExecutionEnvironmentSettings.getApiBase(this.name);
  }

  /** @returns {string} */
  get milbonIdBase() {
    return ExecutionEnvironmentSettings.getMilbonIdBase(this.name);
  }

  /**
   * @returns {{
   *   environment: import('./ExecutionEnvironmentName').ExecutionEnvironmentName,
   *   apiBase: string,
   *   milbonIdBase: string,
   * }}
   */
  toConfig() {
    return {
      environment: this.name,
      ...ExecutionEnvironmentSettings.getSettings(this.name),
    };
  }
}
